(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6349],{

/***/ 93080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ btnActionHandler; }
/* harmony export */ });
/* harmony import */ var _components_WidgetMaker_WidgetsComponents_CMSConstants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67306);

var redirectToNewLink = function(link, newTab) {
    if (!link) return;
    if (newTab) {
        window.open(link, "_blank");
    } else {
        window.location.href = link;
    }
};
var downloadButton = function(link) {
    if (!link) return;
    var downloadLink = document.createElement("a");
    downloadLink.href = "".concat(link, "?download=true");
    downloadLink.target = "_blank";
    downloadLink.rel = "noopener noreferrer";
    downloadLink.download = "file";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
};
var scrollToElement = function(id) {
    if (!id) return;
    var elementContainer = document.getElementById(id);
    if (elementContainer) {
        window.scrollTo({
            behavior: "smooth",
            top: elementContainer.getBoundingClientRect().top - document.body.getBoundingClientRect().top - 5
        });
    }
};
var renderFormComponent = function(handler, callback) {
    callback && callback();
};
var btnActionHandler = function(param) {
    var type = param.type, handler = param.handler, newTab = param.newTab, callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
    switch(type){
        case 1:
        case _components_WidgetMaker_WidgetsComponents_CMSConstants__WEBPACK_IMPORTED_MODULE_0__/* .REDIRECTION_TYPES.link */ .Qf.link:
            redirectToNewLink(handler, newTab);
            break;
        case 2:
            renderFormComponent(handler, callback);
            break;
        case 3:
        case _components_WidgetMaker_WidgetsComponents_CMSConstants__WEBPACK_IMPORTED_MODULE_0__/* .REDIRECTION_TYPES.scrollto */ .Qf.scrollto:
            scrollToElement(handler);
            break;
        case 4:
            downloadButton(handler);
            break;
        case 5:
            return;
    }
};


/***/ }),

/***/ 4285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var src_components_WidgetMaker_WidgetDnD_isMobileDevice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26910);
/* harmony import */ var _RichTextImage_component_TextEditor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74232);
/* harmony import */ var _MultiColumnHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94078);
/* harmony import */ var _Carousel_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58619);
/* harmony import */ var src_components_WidgetMaker_WidgetDnD_WIdgetPropertiesBasic_components_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46976);
/* harmony import */ var src_components_WidgetMaker_utils_buttonConstant__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91850);
/* harmony import */ var _ModernTheme_utils_btnUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93080);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _CardFrameCollection_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(90331);
/* harmony import */ var _components_DesignSystem_AtomicDesignsUtilities_ContentAnimationStyles_module_scss__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(89429);
/* harmony import */ var _components_DesignSystem_AtomicDesignsUtilities_ContentAnimationStyles_module_scss__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_components_DesignSystem_AtomicDesignsUtilities_ContentAnimationStyles_module_scss__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17502);
/* harmony import */ var _multiColumn_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(96268);
/* harmony import */ var _multiColumn_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_multiColumn_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var src_utils_getStringFromHtmlTag__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(35400);
















var REMOVE_GLOBAL_STYLE = [
    "circle",
    "arch",
    "blob"
];
var MultiColumnComponent = function(props) {
    var renderIcon = function renderIcon(columnData) {
        var url = columnData.imageDetail.url;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            style: {
                justifyContent: textAlignment,
                minWidth: isMobile ? "".concat(iconSizeMobile, "px") : "".concat(iconSizeDesktop, "px"),
                width: iconPosition === "left" ? isMobile ? "".concat(iconSizeMobile, "px") : "".concat(iconSizeDesktop, "px") : "100%"
            },
            className: "tw-flex tw-w-[100%]",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: url || "/assets/icons/multi-column-icon.svg",
                className: (_multiColumn_module_scss__WEBPACK_IMPORTED_MODULE_12___default()["custom-border-radius"]),
                style: {
                    height: isMobile ? "".concat(iconSizeMobile, "px") : "".concat(iconSizeDesktop, "px"),
                    width: isMobile ? "".concat(iconSizeMobile, "px") : "".concat(iconSizeDesktop, "px")
                }
            })
        });
    };
    var renderImage = function renderImage(data, index) {
        var url = data.imageDetail.url;
        var shapeStyleCalculated = (0,_CardFrameCollection_utils__WEBPACK_IMPORTED_MODULE_9__/* .getShapeStyles */ .cw)(imageShape, oneGridCellGeometry === null || oneGridCellGeometry === void 0 ? void 0 : oneGridCellGeometry.width);
        var shapeStyle = shapeStyleCalculated[0];
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_8___default()("tw-relative tw-flex-shrink-0 tw-overflow-hidden ".concat(!(REMOVE_GLOBAL_STYLE === null || REMOVE_GLOBAL_STYLE === void 0 ? void 0 : REMOVE_GLOBAL_STYLE.includes(imageShape)) ? "imgWrapperGlobalStyle" : ""), shapeStyle.className),
            style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
                width: "".concat((oneGridCellGeometry === null || oneGridCellGeometry === void 0 ? void 0 : oneGridCellGeometry.width) - (appearance === "card" ? 40 : 0), "px"),
                height: "".concat((oneGridCellGeometry === null || oneGridCellGeometry === void 0 ? void 0 : oneGridCellGeometry.height) - (appearance === "card" ? 40 : 0), "px")
            }, shapeStyle.style || {}), {
                justifyContent: textAlignment
            }),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: url || "/assets/images/richTextWithImage.png",
                className: classnames__WEBPACK_IMPORTED_MODULE_8___default()("tw-absolute tw-h-[100%] tw-w-[100%] tw-object-cover tw-transition-all tw-duration-500", (_components_DesignSystem_AtomicDesignsUtilities_ContentAnimationStyles_module_scss__WEBPACK_IMPORTED_MODULE_15___default())[(0,_CardFrameCollection_utils__WEBPACK_IMPORTED_MODULE_9__/* .getCurrentClass */ .WR)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.hoverType)], shapeStyle.className)
            })
        });
    };
    var renderIconAndImage = function renderIconAndImage(columnData, index) {
        if ((listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.type) === "icon") {
            return isShow && renderIcon(columnData);
        }
        return isShow && renderImage(columnData, index);
    };
    var onNavigate = function onNavigate(e, index) {
        if (activeWidgetId) {
            handleWidgetPropChange({
                subWidget: "",
                subWidgetIndex: -1
            }, activeWidgetId);
            setTimeout(function() {
                handleWidgetPropChange({
                    subWidget: "multiColumn",
                    subWidgetIndex: index,
                    cardFrame: activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : activeWidgetProps.cardFrame
                }, activeWidgetId);
            }, 0);
        }
    };
    var renderCustomHtml = function renderCustomHtml(content) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RichTextImage_component_TextEditor__WEBPACK_IMPORTED_MODULE_2__/* .EditableText */ .s, {
            content: content,
            className: "tw-leading-[22.4px]"
        });
    };
    var renderTitleAndDescription = function renderTitleAndDescription(columnData) {
        var ref;
        var title = columnData.title, description = columnData.description;
        var titleStyle = (0,_MultiColumnHelper__WEBPACK_IMPORTED_MODULE_3__/* .getTitleStyles */ .ij)(cardFrameConfig, isMobile);
        var descriptionStyle = (0,_MultiColumnHelper__WEBPACK_IMPORTED_MODULE_3__/* .getDescriptionStyle */ .TV)(cardFrameConfig, isMobile);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "tw-flex tw-flex-col tw-gap-[8px]",
            children: [
                showTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
                        color: (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.titleColor) || ""
                    }, titleStyle === null || titleStyle === void 0 ? void 0 : titleStyle.style), {
                        textAlign: textAlignment
                    }),
                    children: renderCustomHtml(title)
                }),
                showDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
                        color: cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.descriptionColor
                    }, descriptionStyle === null || descriptionStyle === void 0 ? void 0 : descriptionStyle.style), {
                        textAlign: textAlignment,
                        marginBottom: !(buttonConfig === null || buttonConfig === void 0 ? void 0 : (ref = buttonConfig[0]) === null || ref === void 0 ? void 0 : ref.isShow) ? "16px" : ""
                    }),
                    children: renderCustomHtml(description)
                })
            ]
        });
    };
    var renderButton = function renderButton(columnData) {
        var actionObj = {
            type: (columnData === null || columnData === void 0 ? void 0 : columnData.redirectionType) || "",
            handler: (columnData === null || columnData === void 0 ? void 0 : columnData.redirectUrl) || "",
            newTab: (columnData === null || columnData === void 0 ? void 0 : columnData.isOpenInNewTab) || ""
        };
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "tw-flex ".concat(textAlignment === "center" ? "tw-justify-center" : "", " tw-mb-[16px]"),
            children: buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.map(function(buttonData, btnIndex) {
                var buttonVariant = (0,_Carousel_utils__WEBPACK_IMPORTED_MODULE_4__/* .getButtonVariantsData */ .Tk)(buttonData, false);
                var selectedButtonType = buttonVariant[buttonData.type];
                return buttonData.isShow ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_WidgetMaker_WidgetDnD_WIdgetPropertiesBasic_components_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    size: src_components_WidgetMaker_utils_buttonConstant__WEBPACK_IMPORTED_MODULE_6__/* .BUTTON_SIZE_TYPE.LARGE */ .n6.LARGE,
                    btnType: buttonData.type,
                    buttonData: buttonData,
                    selectedButtonData: selectedButtonType,
                    variant: selectedButtonType.variant,
                    onClick: function() {
                        return (0,_ModernTheme_utils_btnUtils__WEBPACK_IMPORTED_MODULE_7__/* .btnActionHandler */ .c)(actionObj, function() {});
                    },
                    className: "tw-text-[14px] !tw-py-[12px] !tw-min-w-[148px]",
                    children: buttonData === null || buttonData === void 0 ? void 0 : buttonData.text
                }, btnIndex) : null;
            })
        });
    };
    var ref, ref1, ref2;
    var listPresentationConfig = props.listPresentationConfig, cardFrameConfig = props.cardFrameConfig, oneGridCellGeometry = props.oneGridCellGeometry, columnData = props.columnData, index = props.index;
    var ref3 = (0,src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_10__/* .useWidgetDndContextData */ .KX)(), widgetContextState = ref3.widgetContextState, handleWidgetPropChange = ref3.widgetContextHelpers.handleWidgetPropChange;
    var widgets = widgetContextState.widgets, activeWidgetId = widgetContextState.activeWidgetId;
    var activeWidget = widgets === null || widgets === void 0 ? void 0 : widgets[activeWidgetId];
    var activeWidgetProps = activeWidget === null || activeWidget === void 0 ? void 0 : activeWidget.props;
    var isMobile = (0,src_components_WidgetMaker_WidgetDnD_isMobileDevice__WEBPACK_IMPORTED_MODULE_1__/* .isMobileDevice */ .s)();
    var iconSizeDesktop = cardFrameConfig.iconSizeDesktop, iconSizeMobile = cardFrameConfig.iconSizeMobile, iconPosition = cardFrameConfig.iconPosition, iconAlignment = cardFrameConfig.iconAlignment, showTitle = cardFrameConfig.showTitle, showDescription = cardFrameConfig.showDescription, buttonConfig = cardFrameConfig.buttonConfig, textAlignment = cardFrameConfig.textAlignment, imageShape = cardFrameConfig.imageShape, isShow = cardFrameConfig.isShow;
    var appearance = listPresentationConfig.appearance, borderColor = listPresentationConfig.borderColor, backgroundColor = listPresentationConfig.backgroundColor;
    var isSelected = (activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : activeWidgetProps.subWidgetIndex) === index && (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.type) === (activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : (ref = activeWidgetProps.listPresentation) === null || ref === void 0 ? void 0 : ref.type);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        onClick: function(e) {
            e.preventDefault();
            onNavigate(e, index);
            return;
        },
        className: "tw-flex tw-w-[100%]",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, appearance === "card" ? {
                border: isSelected ? "1px solid #2B74D8" : "1px solid ".concat(borderColor || "black"),
                background: backgroundColor,
                padding: isMobile ? "20px 14px" : "24px 20px"
            } : {}, appearance !== "card" && isSelected ? {
                border: "1px solid #2B74D8"
            } : {}), {
                width: oneGridCellGeometry === null || oneGridCellGeometry === void 0 ? void 0 : oneGridCellGeometry.width
            }),
            className: "tw-flex tw-relative tw-gap-[20px] tw-mx-auto tw-cursor-pointer\n          ".concat(iconPosition === "left" ? "tw-flex-row ".concat(iconAlignment === "center" ? "tw-items-center" : "tw-justify-start") : " tw-flex-col ", "\n          ").concat(appearance === "card" ? "imgWrapperGlobalStyle" : "", "\n          "),
            children: [
                isSelected && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "tw-absolute tw-top-[-27.5px] tw-left-0 tw-w-[108px] tw-bg-[#2F80ED] tw-px-[12px] tw-py-[4px] tw-text-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "tw-text-[14px] tw-font-normal tw-text-[#fff]",
                        children: "Column ".concat((activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : activeWidgetProps.subWidgetIndex) + 1)
                    })
                }),
                renderIconAndImage(columnData, index),
                (showTitle && (0,src_utils_getStringFromHtmlTag__WEBPACK_IMPORTED_MODULE_11__/* .getTitleWithoutTags */ .f)(columnData === null || columnData === void 0 ? void 0 : columnData.title) || showDescription && (0,src_utils_getStringFromHtmlTag__WEBPACK_IMPORTED_MODULE_11__/* .getTitleWithoutTags */ .f)(columnData === null || columnData === void 0 ? void 0 : columnData.description) || (buttonConfig === null || buttonConfig === void 0 ? void 0 : (ref1 = buttonConfig[0]) === null || ref1 === void 0 ? void 0 : ref1.isShow)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "tw-flex tw-flex-col tw-gap-[20px]",
                    children: [
                        (showTitle && (0,src_utils_getStringFromHtmlTag__WEBPACK_IMPORTED_MODULE_11__/* .getTitleWithoutTags */ .f)(columnData === null || columnData === void 0 ? void 0 : columnData.title) || showDescription && (0,src_utils_getStringFromHtmlTag__WEBPACK_IMPORTED_MODULE_11__/* .getTitleWithoutTags */ .f)(columnData === null || columnData === void 0 ? void 0 : columnData.description)) && renderTitleAndDescription(columnData),
                        (buttonConfig === null || buttonConfig === void 0 ? void 0 : (ref2 = buttonConfig[0]) === null || ref2 === void 0 ? void 0 : ref2.isShow) && renderButton(columnData)
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (MultiColumnComponent);


/***/ }),

/***/ 35400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ getTitleWithoutTags; }
/* harmony export */ });
/* harmony import */ var _checkRenderEnv__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6337);

var getTitleWithoutTags = function(title) {
    if (_checkRenderEnv__WEBPACK_IMPORTED_MODULE_0__/* .IS_SERVER */ .W6) {
        return title;
    }
    var htmlString = title;
    var tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString;
    var text = tempDiv.textContent || tempDiv.innerText;
    return text;
};


/***/ }),

/***/ 96268:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"custom-border-radius":"multiColumn_custom-border-radius__fktgr"};

/***/ })

}]);